import { EnvironmentVariableEnum } from '../constants/environment-variable.ts';
import { EnvironmentEnum } from '../constants/environment.ts';

export class AppBuildUtil {
  private static _instance: AppBuildUtil;

  static get instance(): AppBuildUtil {
    if (!AppBuildUtil._instance) {
      AppBuildUtil._instance = new AppBuildUtil();
    }

    return AppBuildUtil._instance;
  }

  isProductionBuild(): boolean {
    return EnvironmentVariableEnum.ENVIRONMENT === (EnvironmentEnum.PRODUCTION as string);
  }

  isIntegrationBuild(): boolean {
    return EnvironmentVariableEnum.ENVIRONMENT === (EnvironmentEnum.INTEGRATION as string);
  }
}

export const getAppBuildUtil = (): AppBuildUtil => AppBuildUtil.instance;
